import request from "../util/client";

export function oAuthRequest(service: string) {
    return request<''>('oauth/request', 'POST', { service });
}